import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { usePortalAccess } from '../hooks/usePortalAccess';
import { portalGeneration } from '../services/PortalSession';
import { defaultPreferences } from '../services/sounds/registry';
import { SoundAlertsRuntime } from '../services/sounds/SoundAlertsRuntime';

const SoundAlertsContext = createContext(null);
export const useSoundAlerts = () => useContext(SoundAlertsContext);

export function SoundAlertsProvider({ children, service, request, runtimeOptions = {} }) {
  const access = usePortalAccess();
  const runtime = useRef(null);
  const [state, setState] = useState({
    preferences: defaultPreferences(), status: 'loading', error: '',
    dirty: false, saving: false, playbackStatus: 'inactive', activated: false, canSave: false,
    monitoringStatus: 'inactive',
  });
  useEffect(() => {
    if (!access.dispatcher) return undefined;
    const generation = portalGeneration();
    const instance = new SoundAlertsRuntime({
      ...runtimeOptions, accountId: access.id, service, request,
      current: () => generation === portalGeneration(), notify: setState,
    });
    runtime.current = instance;
    instance.start();
    return () => { instance.dispose(); runtime.current = null; };
    // Root keys the provider by the authenticated session. Injected test dependencies
    // are also lifetime-scoped, never changed while the provider is mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <SoundAlertsContext.Provider value={{
    ...state,
    update: (patch) => runtime.current && runtime.current.update(patch),
    save: () => runtime.current && runtime.current.save(),
    reload: () => runtime.current && runtime.current.refresh(),
    activate: () => runtime.current && runtime.current.activate(),
    preview: (chime) => runtime.current && runtime.current.preview(chime),
  }}>{children}</SoundAlertsContext.Provider>;
}
